/**
 * This is auto-generated code. DO NOT EDIT IT!!
 * Any manual change on this file will disappear on
 * next code generation
 */
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { PlcHttpConfig, PlcHttpConfigToken } from './services.models';

import { UpdatePreferencesRequest } from '../models/update-preferences.request';
import { Preferences } from '../models/preferences.entity';

export type PreferencesUpdatePathVariables = { id: string };

@Injectable()
export class PreferencesService {
	constructor(
		@Inject(PlcHttpConfigToken) private config: PlcHttpConfig,
		private http: HttpClient,
	) {}

	public update(
		path: PreferencesUpdatePathVariables,
		body: UpdatePreferencesRequest,
	): Observable<Preferences> {
		return this.http.patch<Preferences>(
			`${this.config.apiUrl}/api/v2/private/users/${path.id}/preferences`,
			body,
		);
	}
}
